import { Dialog as MuiDialog, DialogProps as MuiDialogProps } from '@mui/material';
import React from 'react';

import { CenteredSpinner } from '../CircularProgress';
import { DialogTitle } from './DialogTitle';

type DialogProps = Omit<MuiDialogProps, 'title'> & {
    title?: React.ReactNode;
};

const Fallback: React.FunctionComponent = () => {
    return (
        <CenteredSpinner
            sx={{
                height: '70vh',
            }}
        />
    );
};

export const Dialog = React.forwardRef<unknown, DialogProps>(({ children, title, ...props }, _) => {
    const onClose = props.onClose ?? (() => {});
    return (
        <MuiDialog fullWidth={true} {...props}>
            {title && <DialogTitle title={title} onClose={(e) => onClose(e, 'escapeKeyDown')} />}
            <React.Suspense fallback={<Fallback />}>{children}</React.Suspense>
        </MuiDialog>
    );
});
